<template>
  <div class="home-container">
    <!-- banner轮播图 -->
    <swiper />
    <!-- 应用商店 -->
    <application />
    <!-- 解决方案 -->
    <plan />
    <!-- 交流平台 -->
    <platform />
    <!-- 新闻资讯 -->
    <news />
  </div>
</template>



<script>
import swiper from './components/swiper/index.vue'
import application from './components/application/index.vue'
import plan from './components/plan/index.vue'
import platform from './components/platform/index.vue'
import news from './components/news/index.vue'
export default {
  components: {
    swiper,
    application,
    plan,
    platform,
    news
  }
};
</script>
<style lang="less" scoped>
.home-container {
  margin-top: -60px;
}
</style>
